import { render, staticRenderFns } from "./IndustryPie.vue?vue&type=template&id=7654c57a"
import script from "./IndustryPie.vue?vue&type=script&lang=js"
export * from "./IndustryPie.vue?vue&type=script&lang=js"
import style0 from "./IndustryPie.vue?vue&type=style&index=0&id=7654c57a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports